import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon
  const [structures, setStructures] = useState([]);
  const [sections, setSections] = useState([]);
  const [opSections, setOpSections] = useState(() => {
    try { const op = JSON.parse(localStorage.getItem("gr_firma_op") || "null"); return op?.sections || []; } catch { return []; }
  });
  const [selectedStructure, setSelectedStructure] = useState("all");
  const [companyLogo, setCompanyLogo] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      const structs = (data.structures || []).slice().sort((a, b) => (a.nome || "").localeCompare(b.nome || "", "it"));
      setStructures(structs);
      setSelectedStructure((prev) => (structs.length === 1 ? structs[0].id : (prev || "all")));
      setSections(data.sections || []);
      setCompanyLogo(data.company_logo || "");
    } catch {
      setUser(false);
    }
  };

  useEffect(() => { load(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gr_token", data.access_token);
    await load();
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("gr_token");
    localStorage.removeItem("gr_firma_op");
    setOpSections([]);
    setUser(false); setStructures([]); setSections([]);
  };

  const can = (section) => sections.includes("*") || sections.includes(section) || opSections.includes(section);

  return (
    <AuthCtx.Provider value={{ user, structures, sections, opSections, setOpSections, selectedStructure, setSelectedStructure, companyLogo, login, logout, can, reload: load }}>
      {children}
    </AuthCtx.Provider>
  );
}
